import styled from 'styled-components';
import { media } from '~constants/media';

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  margin-top: 43px;
  padding: 25px 29px 22px 27px;
  border-radius: 10px;
  color: #000;
  background-color: white;
  font-weight: 300;
  font-size: 16px;
  line-height: 18px;

  &:before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 36px;
    transform: rotate(180deg);
    border-width: 13px;
    border-style: solid;
    border-color: white transparent transparent transparent;
  }

  ${media.md`
    font-size: 18px;
    line-height: 20px;
    padding: 37px 35px 30px 36px;
  `}
`;
